/**
 * Copyright © 2018-present Emu Analytics
 */

import FormData from 'form-data';
import { IMedia, IMetadata } from './api-interfaces';
import { BaseEndpoints } from './base.endpoints';
import { Client } from './client';

interface IMediaUploadRequest {
  type: string;
  mimeType?: string;
  metadata?: IMetadata;
  fileName: string;
  data: any;
}

export class MediaEndpoints extends BaseEndpoints<IMedia> {
  constructor(client: Client) {
    super(client, 'media');
  }

  async upload(
    mediaId: string,
    request: IMediaUploadRequest,
    params: Record<string, any> = {}
  ): Promise<IMedia> {
    const form = new FormData();

    form.append('id', mediaId);

    if (request.type) {
      form.append('type', request.type);
    }

    if (request.mimeType) {
      form.append('mimeType', request.mimeType);
    }

    if (request.metadata) {
      form.append('metadata', JSON.stringify(request.metadata));
    }

    form.append('file', request.data, request.fileName);

    const media: IMedia = await this.client._post(this.resourceEndpoint, form, {
      // Note - only Node FormData supports getHeaders
      headers: form.getHeaders?.() ?? { 'Content-Type': 'multipart/form-data' },
      params
    });

    return media;
  }

  content(mediaId: string): Promise<any> {
    return this.client._get(`${this.resourceEndpoint}/${mediaId}/content`, { responseType: 'stream' });
  }
}
